import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';

@Component({
  selector: 'app-cost-of-waiting',
  templateUrl: './cost-of-waiting.component.html',
  styleUrls: ['./cost-of-waiting.component.css']
})
export class CostOfWaitingComponent implements OnInit {
  title: string;
  titleDescription: string;
  public barChartData: any[];
  hcDataV2: any;
  view: any;
  public barChartOptions = {
    barPadding: 200,
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    yAxisLabel: 'Population',
    roundEdges: false,
    view: [300, 300],
    colorScheme: {
      domain: ['#3385C5', '#3385C5', '#3385C5']
    }
  }
  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);
  yAxisTickFormatting(value) {
    return Utils.formatToCurrency(value);
  }
  constructor( @Inject(MAT_DIALOG_DATA) data,
  public dialogRef: MatDialogRef<CostOfWaitingComponent>,) { 
    this.hcDataV2 = data.hcDataV2;
    this.view = [innerWidth / 2.4, 400];
  }

  ngOnInit() {
    this.title = "Cost of Waiting"
    this.titleDescription = "The proposed investment required to fund healthcare will grow quickly over time, so it is advantageous to act<br/> as soon as possible."
    this.generateBarChartData();
  }
  generateBarChartData() {
    this.barChartData = [
      {
        "name": "Today",
        "value":  this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": (this.hcDataV2.Illustrations.length >= 3) ? this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0) : 0
      },
      {
        "name": "5 Years",
        "value": (this.hcDataV2.Illustrations.length >= 5) ? this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0) : 0
      }
    ]
  }

  formatDataLabel(value)
  {
    return Utils.formatToCurrency(value);
    //return "$" + value
  }
  
  close(): void {
    this.dialogRef.close();
  }

}
